import GameFactory from "../../vendor_core/factories/GameFactory";
import BBReelGroup from "./view/BBReelGroup";
import Reel from "../../vendor_core/core/src/views/Reel";
import BBWinlinesView from "./view/BBWinlinesView";
import BBWinSymbolsView from "./view/BBWinSymbolsVew";
import BaseSettings from "../../vendor_core/core/src/ui/BaseSettings";
import BBSettings from "./view/BBSettings";
import ReelReverseCascadeBehaviour from '../../vendor_core/core/src/spinners/ReelReverseCascadeBehaviour';
import BBReelReverseCascadeBehaviour from "./view/BBReelReverseCascadeBehaviour";
import GameModel from "../../vendor_core/core/src/model/GameModel";
import BaseUI from "../../vendor_core/core/src/ui/BaseUI";
import BBUIDesktop from "./view/BBUIDesktop";
import BBReelSymbol from "./view/BBSymbol";
import BBPreloadView from './view/BBPreloadView';

/**
 * Factory for creating game specific objects
 */
class BBGameFactory extends GameFactory {
    protected getSettings(): BaseSettings {
        return new BBSettings();
    }

    protected getPreloadView(): BBPreloadView {
        return new BBPreloadView();
    }

    protected getUIView(): BaseUI {
        if (GameModel.isMobile()) {
            // return new UIMobileView()
            return new BBUIDesktop();
        } else {
            return new BBUIDesktop();
        }
    }
    protected getReelGroup() {
        return new BBReelGroup();
    }

    protected getSymbol() {
        return new BBReelSymbol();
    }

    protected getWinSymbolsView() {
        return new BBWinSymbolsView();
    }

    protected getWinlinesView() {
        return new BBWinlinesView();
    }
    protected getSpinBehaviour(params: { reel: Reel; sortFunction: any }) {
        return (new BBReelReverseCascadeBehaviour(params.reel, params.sortFunction) as unknown) as ReelReverseCascadeBehaviour;
        // return new ReelReverseCascadeBehaviour(params.reel, params.sortFunction);
        // return new ReelCascadeArrangeBehaviour(params.reel, params.sortFunction);
    }

    protected getClassicReel(params: {
        reelGroup: any;
        container: any;
        reelIdx: any;
    }) {
        return new Reel(params.container, params.reelIdx);
    }
}

export default BBGameFactory;
